// extracted by mini-css-extract-plugin
module.exports = {"koplaTeaser":"KoplaTeaser_koplaTeaser__ayjJ_","imageContainer":"KoplaTeaser_imageContainer__MDreQ"};